module.exports = __webpack_public_path__ + "static/img/RSFUPS116R_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RSFUPS116R_1.png
// module id = utiF
// module chunks = 0